module.exports = __webpack_public_path__ + "static/media/security.4aa7dc7f.svg";